import React, { useEffect, useRef, useState } from 'react';
import stores from 'cd-eft/models/Stores';
import { observer } from 'mobx-react';
import { DynamicThreeCrossSectionProfile } from 'cd-eft/components/common/DynamicProfile/DynamicThreeCrossSectionProfile';
import { DynamicCrossSectionHub } from 'cd-eft/models/Stores/DynamicProfile/CrossSection/DynamicCrossSectionHub';
import { ProfileStoreType } from 'cd-eft/models/Stores/DynamicProfile/DynamicProfileEnums';
import { EngineeringMapService } from 'cd-eft/framework/mapServices/EngineeringMapServices';
import { ThreeCrossSectionVM } from './ThreeCrossSectionVM';
import { DynamicTableStoreBase } from 'cd-eft/models/Stores/DynamicProfile/DynamicTableStoreBase';
import { DynamicProfileStoreBase } from 'cd-eft/models/Stores/DynamicProfile/DynamicProfileStoreBase';
import './crosssection.scss';
import { Accordion } from 'cd-eft/components/common/Accordion';
import { Table, CardBody, CardFooter, Card } from 'reactstrap';
import Icon from '@mdi/react';
import { mdiClose, mdiChevronLeft, mdiChevronRight, mdiChevronUp, mdiChevronDown } from '@mdi/js';
import { Popup } from 'cd-eft/components/common/Popup';
import { FlatButton } from 'nrcs-design-system';
import { Alert } from 'cd-eft/components/common/Alert';
import Draggable from 'react-draggable';
import { ProfileSettingsContainer } from '../common/ProfileSettingsContainer/ProfileSettingsContainer';

const { designStore, threeCrossSectionDesignStore,waterwayDesignStore } = stores.AppStore;

const ThreeCrossSectionComponent = (props) => {
    const [waitingInit, setWaitingInit] = useState(true)

    let profileHub: DynamicCrossSectionHub;
    const profileStoreRef1 = useRef<DynamicProfileStoreBase>();
    const profileStoreRef2 = useRef<DynamicProfileStoreBase>();
    const profileStoreRef3 = useRef<DynamicProfileStoreBase>();
    const profileTableStoreRef = useRef<DynamicTableStoreBase>();

    if (!profileTableStoreRef.current && !profileStoreRef1.current && !profileStoreRef2.current && !profileStoreRef3.current) {
        profileHub = new DynamicCrossSectionHub();
        profileHub.createStore(ProfileStoreType.PROFILE, void 0, true);
        profileStoreRef1.current = profileHub.ProfileStore1;
        profileStoreRef2.current = profileHub.ProfileStore2;
        profileStoreRef3.current = profileHub.ProfileStore3;
        profileHub.createStore(ProfileStoreType.TABLE);
        profileTableStoreRef.current = profileHub.TableStore;
    }

    const vm = useRef(new ThreeCrossSectionVM({ 
        ...props,
        profileTableStore: profileTableStoreRef.current,
        profileStoreRef1: profileStoreRef1.current,
        profileStoreRef2: profileStoreRef2.current,
        profileStoreRef3: profileStoreRef3.current,
    })).current;

    const currentObject = threeCrossSectionDesignStore.threeCrossSectionObject;
    const lastReachIndex = vm.currentObject.waterwayReachStations.findIndex((station) => station.reachId === 'R-last');
    const R0Index = vm.currentObject.waterwayReachStations.findIndex((station) => station.reachId === 'R-0');
    const mainId = currentObject.mainReachStation;

    useEffect(() => {
        vm?.onMount();
    
        const scrollableElement = document.getElementById('tcs-card-body');
        const mainProfile = document.getElementById('mainProfile');
        if (scrollableElement && mainProfile) {
            const middlePosition = mainProfile.offsetTop;
            scrollableElement.scrollTop = middlePosition;
        }
        if (profileHub.ProfileStore3) {
            profileHub.ProfileStore3.disableButton = (state: boolean) => {
                setWaitingInit(state);
            };
        }
    
        function cleanup() {
            threeCrossSectionDesignStore.resetCurrentObject();
            vm.onUnmount();
        }
    
        return cleanup;
    }, []);

    useEffect(() => {   
        if (waterwayDesignStore.threeCrossSectionTableViewToggle) {
            vm.jumpToStation(waterwayDesignStore.threeCrossSectionStation); 
            waterwayDesignStore.threeCrossSectionTableViewToggle = false;
        }    
    }, [waterwayDesignStore.threeCrossSectionTableViewToggle]);
    
        return (
        <div id="three-crosssection-container" style={{minWidth: '320px', minHeight: '480px'} } >
            <div id="ne-resizer" className ="tcs-resizer resizer-corner"></div>
            <div id="nw-resizer" className ="tcs-resizer resizer-corner"></div>
            <div id="se-resizer" className ="tcs-resizer resizer-corner"></div>
            <div id="sw-resizer" className ="tcs-resizer resizer-corner"></div>
            <div id="n-resizer" className ="tcs-resizer"></div>
            <div id="e-resizer" className ="tcs-resizer"></div>
            <div id="s-resizer" className ="tcs-resizer"></div>
            <div id="w-resizer" className ="tcs-resizer"></div>
                <div className="tcs-body-container">
                <div id='tcs-header'>
                    <h1 className="h5 mt-1 mb-1 ml-1">Three Cross Section</h1>
                    <button className="tcs-close" aria-label="close tool" onClick={() => designStore.hideThreeCrossSection = true}>
                        <Icon path={mdiClose} title="Close" size={1} />
                    </button>
                </div>
                    <Card className="tcs-body">
                    <CardBody className="tcs-card-body" id='tcs-card-body'>
                        <Accordion data-test-id="Accordian1" className="pb-0 pl-3 pr-3" headers={[vm.stationName1 ? 'Station ' + vm.stationName1 : '']} expanded={vm.isProfileFirstVisible} >
                            <DynamicThreeCrossSectionProfile profileStore={profileStoreRef1.current} editable={false} profileNumber={'threeCrossSection1'} />
                        </Accordion>
                        <div id='mainProfile'>
                            <Accordion className="pb-0 pl-3 pr-3" headers={['Station ' + vm.stationName2]} expanded={vm.isProfileMiddleVisible} >
                                    <DynamicThreeCrossSectionProfile profileStore={profileStoreRef2.current} editable={false} profileNumber={'threeCrossSection2'} generateInitialProfiles={vm.initThreeCrossSectionProfiles}/>
                            </Accordion>
                        </div>
                        <Accordion className="pb-0 pl-3 pr-3" headers={[vm.stationName2 ? ('Cross Section: Station ' + vm.stationName2) : '']} expanded={vm.isProfileMiddleVisible} >
                            <div className="tcs-table-container">
                                <Table className="crossSection-table">
                                    <thead>
                                        <tr>
                                            <th>Distance</th>
                                            <th>Original Elevation</th>
                                            <th>Design Elevation</th>
                                            <th>Cut/Fill Height</th>
                                        </tr>
                                    </thead>
                                    <tbody>                                   
                                        {currentObject && currentObject.threeCrossSectionPoints.map((crossSectionPoint: any, i: number) => (
                                            <tr
                                                key={'key-crossSectionPoint-' + i}
                                                onMouseEnter={() => vm.handleRowMouseEnter(crossSectionPoint)}
                                                onMouseLeave={vm.handleRowMouseLeave}
                                            >
                                                <td>
                                                    <p
                                                        style={{ width: "80px" }}
                                                        aria-label={`distance-${i}`}
                                                        data-testid={`distance-${i}`}
                                                    >{Number(crossSectionPoint.distance).toFixed(1)}</p>
                                                </td>
                                                <td>
                                                    <p
                                                        style={{ width: "80px" }}
                                                        aria-label={`originalElevation-${i}`}
                                                        data-testid={`originalElevation-${i}`}
                                                    >{Number(crossSectionPoint.originalElevation).toFixed(1)}</p>
                                                </td>
                                                <td>
                                                    <p
                                                        style={{ width: "80px" }}
                                                        aria-label={`designElevation-${i}`}
                                                        data-testid={`designElevation-${i}`}
                                                    >{Number(crossSectionPoint.designElevation).toFixed(1)}</p>
                                                </td>
                                                <td>
                                                    <p
                                                        style={{ width: "80px" }}
                                                        aria-label={`cutFillHeight-${i}`}
                                                        data-testid={`cutFillHeight-${i}`}
                                                    >{Number(crossSectionPoint.cutFillHeight).toFixed(1)}</p>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                        </Accordion>
                        <Accordion className="pb-0 pl-3 pr-3" headers={[vm.stationName3 ? 'Station ' + vm.stationName3 : '']} expanded={vm.isProfileThirdVisible}>
                                <DynamicThreeCrossSectionProfile profileStore={profileStoreRef3.current} editable={false} profileNumber={'threeCrossSection3'} />
                        </Accordion>
                    </CardBody>
                    <CardFooter className="tcs-card-footer">                   
                        <section className='tcs-profile-controll'>                      
                            <div className='tcs-footer-section' style={{float:'left'}}>
                                <div style={{float:'left'}}>
                                    <label id="blank" className={'tcs-profile-label place-holder'}>-</label>
                                    <FlatButton
                                        title={'Back'}
                                        iconLeft={mdiChevronLeft}
                                        onClick={vm.moveBackStation}
                                        className={'tcs-profile-btn left-btn'}
                                        disabled={mainId <= R0Index || waitingInit}
                                        color={'#707070'}
                                        >
                                        <span className={`btn-link ${mainId <= R0Index || waitingInit ? 'disabled-text' : ''}`}>Back</span>
                                    </FlatButton>
                                </div>
                                <div style={{float:'left'}}>
                                    <label id="Station" htmlFor='stationName2' className={'tcs-profile-label'}>Station</label>
                                    <input
                                        className='tcs-profile-input'
                                        type="text"
                                        name='stationName2'
                                        id='stationName2'
                                        value={[vm.stationName2]}
                                        onChange={(event) => vm.handleInputOnChange(event)}
                                        onBlur={(event) => vm.handleInputOnBlur(event)}
                                        onFocus={(event) => vm.handleInputOnFocus(event)}
                                    />
                                </div>
                                <div style={{float:'left'}}>
                                    <label id="blank" className={'tcs-profile-label place-holder'}>-</label>
                                    <FlatButton
                                        title={'Next'}
                                        iconRight={mdiChevronRight}
                                        onClick={vm.moveNextStation}
                                        className={'tcs-profile-btn right-btn'}
                                        disabled={mainId >= lastReachIndex || waitingInit}
                                        color={'#707070'}
                                        >
                                        <span className={`btn-link ${mainId >= lastReachIndex || waitingInit ? 'disabled-text' : ''}`}>Next</span>
                                    </FlatButton>
                                </div>
                            </div>
                            <div className='tcs-footer-section' style={{float:'left'}}>
                                <div style={{float:'left'}}>
                                    <label id="blank" className={'tcs-profile-label place-holder'}>-</label>
                                    <FlatButton
                                        title={'Down'}
                                        iconLeft={mdiChevronDown}
                                        onClick={vm.downIncrement}
                                        className={'tcs-profile-btn left-btn'}
                                        disabled={vm.stationIncrement <= 5 || waitingInit}
                                        color={'#707070'}
                                        >
                                        <span className={`btn-link ${vm.stationIncrement <= 5 || waitingInit ? 'disabled-text' : ''}`}>Down</span>
                                    </FlatButton>
                                </div>
                                <div style={{float:'left'}}>
                                    <label id="Station" htmlFor="stationIncrement" className={'tcs-profile-label'}>Increment</label>
                                    <input
                                        name="stationIncrement"
                                        id="stationIncrement"
                                        className='tcs-profile-input'
                                        value={vm.stationIncrement}
                                        type='number'
                                        onChange={vm.handleInputOnChange}
                                        onBlur={vm.handleInputOnBlur}
                                        onFocus={vm.handleInputOnFocus}
                                    ></input >
                                </div>
                                <div style={{float:'left'}}>
                                    <label id="blank" className={'tcs-profile-label place-holder'}>-</label>
                                    <FlatButton
                                        title={'Up'}
                                        iconRight={mdiChevronUp}
                                        onClick={vm.upIncrement}
                                        className={'tcs-profile-btn right-btn'}
                                        disabled={waitingInit}
                                        color={'#707070'}
                                        >
                                        <span className={`btn-link ${waitingInit ? 'disabled-text' : ''}`}>Up</span>
                                    </FlatButton>
                                </div>                             
                            </div>                          
                            {vm.imageSavedSuccessful && (
                                <tr>
                                    <td colSpan={4}>
                                        <Alert show={vm.imageSavedSuccessful} type="success" title={<SuccessMessage />} />
                                    </td>
                                </tr>
                            )}
                            {vm.imageSavedError && (
                                <tr>
                                    <td colSpan={4}>
                                        <Alert show={vm.imageSavedError} type="error" msg={vm.errorMsg} />
                                    </td>
                                </tr>
                            )}
                        </section>
                        <hr />
                        <div>
                            <button className={`float-left usa-button usa-button--outline nobr`} onClick={vm.openViewControls} data-testid="profile-controls-button">
                                View Controls
                            </button>
                            <div className="save-button-container">
                                <button className="usa-button usa-button--outline tcs-cancel-btn" aria-label="Cancel" onClick={vm.onClickCancelCrossSec}>
                                    Close
                                </button>
                                    <button className="usa-button" aria-label="Save" disabled={!vm.profileStore2.isMainSecDisplay || designStore.isLoading} onClick={() => vm.onClickSaveCrossSec(profileStoreRef2.current?._profileView)}>
                                    Save for Report
                                </button>
                            </div>
                        </div>
                    </CardFooter>
                </Card>
            </div>

            {vm.profileControlsForm.profileControlsPopUpActive &&
                <Draggable
                    axis="both"
                    positionOffset={{ x: '-50%', y: '-50%' }}
                    cancel="input"
                >
                    <div className='profile-controls-container'>
                        <ProfileSettingsContainer 
                            profileSettingsForm={vm.profileControlsForm} 
                            formValidation={vm.formValidation} 
                            toggleFineGrid={vm.toggleFineGrid}
                            handleCancelProfileSettings={vm.handleCancelProfileSettings}
                            handleSaveProfileSettings={vm.handleSaveProfileSettings} 
                            previewProfileSettingsHandler={vm.previewProfileSettingsHandler}
                            title={'Three Cross Section'}
                            saveButtonText={'Save'}
                            parentType="Three Cross Sections"
                        />
                    </div>
                </Draggable>
            }
        </div>
    )
}
const SuccessMessage = () => (
    <>
        <div className="mt-1" style={{ whiteSpace: "nowrap", textAlign: "right" }}> The cross section is successfully saved</div>
    </>
);
export const ThreeCrossSection = observer(ThreeCrossSectionComponent);